import { atom, selectorFamily } from 'recoil';
import { PrivilegeService } from 'api';
export const getPendingPrivilegesRequestId = atom({
  key: 'getPendingPrivilegesRequestId',
  default: 0
});
export const customerPendingPrivilegesPagination = atom({
  key: 'customerPendingPrivilegesPagination',
  default: {
    max: 10,
    offset: 0
  }
});
export const searchCustomerPendingPrivileges = selectorFamily({
  key: 'getCustomerPendingPrivileges',
  get: customerId => async ({
    get
  }) => {
    get(getPendingPrivilegesRequestId);
    if (!customerId) return null;
    const pagination = get(customerPendingPrivilegesPagination);
    try {
      const privileges = await PrivilegeService.searchPendingPrivileges({
        customerId,
        body: {
          ...pagination
        }
      });
      return privileges;
    } catch (error) {
      console.error('Could not fetch pending privileges for the customer', error);
      return null;
    }
  }
});